// extracted by mini-css-extract-plugin
export var button = "LaunchButton-module--button--2cldu";
export var bxTextTruncateEnd = "LaunchButton-module--bx--text-truncate--end--1POlr";
export var bxTextTruncateFront = "LaunchButton-module--bx--text-truncate--front--ktvJu";